// import axiosInstance from "../utils/axios/axios";
import privateAxiosInstance from "../utils/axios/private";
import publicAxiosInstance from "../utils/axios/public";
import { hybridEncrypt, hybridDecrypt } from "../utils/crypto";

/**
 * Candidate-related API calls
 */
export const flowwiseApi = {
    /**
     * Apply for a job or opportunity
     */
    async start() {
        try {
            // const encryptedPayload = await hybridEncrypt(payload);
            const response = await privateAxiosInstance.post("/flowise/start/");
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async process(payload) {
        try {
            const encryptedPayload = await hybridEncrypt(payload);
            const response = await privateAxiosInstance.post("/flowise/submit/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async cheatingTryApi(payload) {
        try {
            const encryptedPayload = await hybridEncrypt(payload);
            const response = await publicAxiosInstance.post("/interview/cheat-trying/", encryptedPayload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async end(payload) {
        try {
            const response = await privateAxiosInstance.post("/flowise/end/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async getReport(params = {}) {
        try {
            const response = await privateAxiosInstance.get("/flowise/report/", { params });
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async getFilteredReport(payload, page = 1, page_size = 5) {
        try {
            const response = await privateAxiosInstance.post("/flowise/report/filter/", payload, {
                params: {
                    page,
                    page_size,
                },
            });
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async downloadReport(params = {}) {
        try {
            const response = await privateAxiosInstance.get("/flowise/export/", { params, responseType: "blob" });
            // if (response.data.encrypted) {
            //     return await hybridDecrypt(response.data);
            // }
            return {
                status: response.status,
                data: response.data, // Blob
            };
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    message:
                        "Network error. Please check your internet connection.",
                };
            }

            return {
                status: error.response?.status || 500,
                message:
                    error.response?.data?.message ||
                    "Failed to download report.",
            };
        }
    },


    async getConsolation(payload = {}) {
        try {
            const response = await privateAxiosInstance.post("/flowise/reasoning/", payload);

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }

            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    message: "Network error",
                };
            }
            return error.response.data;
        }
    },

    async inactive(payload = {}) {
        try {
            const response = await privateAxiosInstance.post("/flowise/inactive/", payload);

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }

            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    message: "Network error",
                };
            }
            return error.response.data;
        }
    },

    async heartbeat(payload = {}) {
        try {
            const response = await privateAxiosInstance.post("/flowise/heartbeat/", payload);

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }

            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    message: "Network error",
                };
            }
            return error.response.data;
        }
    }
}